export const requestedLine = (canBuy: boolean, requestedTotal: number) => {
  const moved = requestedTotal === 1 ? 'Continuing moves the user to the requested list.' : 'Continuing moves the users to the requested list.'
  if (!canBuy) {
    return moved
  }
  return requestedTotal === 1
    ? `${moved} Buy a seat in the next step to send the invitation right away.`
    : `${moved} Buy the seats in the next step to send the invitations right away.`
}
